var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "float-links" }, [
    _c("ul", { attrs: { "data-spm": "fx" } }, [
      _c("li", { staticClass: "back-top" }, [
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0)" },
            on: { click: _vm.goRefresh },
          },
          [
            _c("img", {
              staticClass: "fb-icon",
              attrs: { src: require("../images/icon_refresh.png") },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "user-feedback", attrs: { id: "feedBackBtn" } },
        [_c("FeedBackBtn")],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "back-top", attrs: { "data-role": "go_top" } },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showBackUp,
                    expression: "showBackUp",
                  },
                ],
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.goTop },
              },
              [
                _c("img", {
                  staticClass: "fb-icon",
                  attrs: {
                    src: "//statics.itc.cn/mptc-mpfe/img/components-pc/icon_Up.png",
                  },
                }),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass: "back-sohu prize-survey",
        attrs: { "data-role": "on_back" },
      },
      [
        _c(
          "a",
          {
            attrs: {
              href: "http://www.sohu.com?strategyid=24",
              target: "_blank",
            },
          },
          [
            _c("img", {
              staticClass: "fb-icon",
              attrs: {
                src: "//statics.itc.cn/mptc-mpfe/img/components-pc/logo_sohu.png",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "tooltip" }, [
              _c("div", { staticClass: "side-sohu-tooltip" }, [
                _vm._v("返回首页"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "side-sohu-three" }),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }